import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { ProgressPage } from 'pages/progress/progress';

@NgModule({
    declarations: [ProgressPage],
    imports: [PagesModule, ComponentsModule],
    exports: [ProgressPage]
})
export class ProgressPageModule {}
